import { Component, Input, inject } from '@angular/core';
import { AdminService } from '../../../admin/admin.service';
import { Unit } from '../../../models/admin-models';
import { Platform } from '@angular/cdk/platform';
import { ReportingService } from '../../reporting.service';
import { saveAs } from '@progress/kendo-file-saver';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-unit-profile-history',
  templateUrl: './unit-profile-history.component.html',
  styleUrls: ['./unit-profile-history.component.scss'],
  standalone: false,
})
export class UnitProfileHistoryComponent {
  private admnSvc = inject(AdminService);
  private pltfrm = inject(Platform);
  private rptSvc = inject(ReportingService);
  dialog = inject(MatDialog);

  @Input() baseUrl;

  unitProfileHistoryData;
  units: Unit[] = [] as Unit[];
  filteredUnits;
  selectedUnit;
  selectedApp;
  reportTypes: string[];
  selectedType;
  loading = false;
  ptApps = ['dl', 'arl', 'fpml', 'amal'];

  getUnitProfileHistory(ev) {
    this.selectedApp = ev.app;

    this.rptSvc.getUnitProfileHistory(ev).subscribe({
      next: data => {
        const ogData = data.results.reverse();
        this.unitProfileHistoryData = [...ogData];
      },
      error: error => {
        console.error(error);
      },
    });
  }

  getUnitProfileReport(ev) {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.loading = true;
        const iosSafari =
          this.pltfrm.IOS ||
          (navigator?.['userAgentData']?.platform === 'macOS' &&
            navigator.maxTouchPoints > 1);

        this.admnSvc
          .getUnitProfileReport(
            this.selectedUnit,
            this.selectedApp,
            this.selectedType
          )
          .subscribe(data => {
            const filename = `${this.selectedUnit}_${this.selectedApp}_${this.selectedType}_report.pdf`;

            let fileData;
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename, {
                proxyURL: `${this.baseUrl}/util/proxy`,
                proxyTarget: '_self',
                forceProxy: iosSafari,
              });
            };
            this.loading = false;
          });
      }
      dialogRef = null;
    });
  }

  download(ev, id, type) {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.admnSvc
          .downloadHistoricUnitProfile(id, this.selectedApp, type)
          .subscribe({
            next: data => {
              let fileData;
              const filename = `${this.selectedApp}-unitProfile-${id}.${type}`;
              const reader = new FileReader();
              reader.readAsDataURL(data);

              reader.onloadend = () => {
                fileData = reader.result;
                saveAs(fileData, filename);
              };
            },
            error: error => {
              console.error(error);
            },
          });
      }
      dialogRef = null;
    });
  }
}
